export namespace RecentlyViewed {
    /**
     * Module configs
     */
    export interface IConfig {
        mode?: 'top' | 'child' | 'any';
        limit?: number;
    }

    export const EVENT = 'recentlyViewed.next';
}
